import Axios from 'axios';

const origin = window.location.origin;

let api = null;
let authApi = null;
let onUnauthorized = null;

// Endpunkte, bei denen der 401-Handler NICHT feuern soll
const AUTH_PATHS = [/\/login\b/];

export function initAxios(cfg = {}, opts = {}) {
  onUnauthorized = typeof opts.onUnauthorized === 'function' ? opts.onUnauthorized : null;

  const apiBase  = (cfg.apiBaseUrl  || origin + '/api').replace(/\/+$/, '');
  const authBase = (cfg.authBaseUrl || apiBase + '/login').replace(/\/+$/, '');

  // Öffentliche Instanz (keine Token-Header, kein 401-Dialog)
  authApi = Axios.create({ baseURL: authBase, timeout: 5000 });
  // Authentifizierte Instanz
  api = Axios.create({ baseURL: apiBase, timeout: 5000 });
  // Token nur anhängen, wenn vorhanden
  api.interceptors.request.use((req) => {
    const token = sessionStorage.getItem('access_token');
    req.headers = req.headers || {};
    if (token) req.headers.Authorization = `Bearer ${token}`;
    else delete req.headers.Authorization;
    return req;
  });
  // 401 global behandeln – aber Auth-Routen ausnehmen
  api.interceptors.response.use(
    (r) => r,
    (err) => {
      const status = err?.response?.status;
      const url = String(err?.config?.url || '');
      if (status === 401 && !AUTH_PATHS.some(rx => rx.test(url))) {
        if (onUnauthorized) try { onUnauthorized(err); } catch {}
      }
      return Promise.reject(err);
    }
  );

  return { api, authApi };
}

export function getApi() {
  if (!api) throw new Error('Axios (api) nicht initialisiert – initAxios() zuerst aufrufen.');
  return api;
}
export function getAuthApi() {
  if (!authApi) throw new Error('Axios (authApi) nicht initialisiert – initAxios() zuerst aufrufen.');
  return authApi;
}

const apiProxy = new Proxy(function () {}, {
  get(_t, prop) {
    const inst = getApi();
    const value = inst[prop];
    return (typeof value === 'function') ? value.bind(inst) : value;
  },
  apply(_t, thisArg, argArray) {
    const inst = getApi();
    return inst.apply(thisArg, argArray);
  }
});

const authApiProxy = new Proxy(function () {}, {
  get(_t, prop) {
    const inst = getAuthApi();
    const value = inst[prop];
    return (typeof value === 'function') ? value.bind(inst) : value;
  },
  apply(_t, thisArg, argArray) {
    const inst = getAuthApi();
    return inst.apply(thisArg, argArray);
  }
});

export function getAuthApiProxy() {
  return authApiProxy
}

export default apiProxy;